export default function AttIcon({ naziv }) {
  function getFirst() {
    if (!naziv) return '';
    if (naziv.startsWith('IV')) return '4';
    if (naziv.startsWith('III')) return '3';
    if (naziv.startsWith('II')) return '2';
    if (naziv.startsWith('I')) return '1';
    return '';
  }

  return (
    <div className="icon-container">
      <div className="icon-style">{getFirst()}</div>
    </div>
  );
}
